/**
 * Shared UI primitives + constants for the Stylist Marketplace (Batch 1).
 *
 * Kept in one file so /stylists (grid), /stylists/:id (public profile) and
 * /stylist-studio (owner dashboard) render consistent chips/scores without
 * duplicating markup. Downstream batches (portfolio, bookings) can extend
 * this module.
 */
export const SPECIALTY_LABELS = {
  office: "Office",
  wedding: "Wedding",
  party: "Party",
  vacation: "Vacation",
  luxury: "Luxury",
  streetwear: "Streetwear",
  traditional: "Traditional",
  minimal: "Minimal",
  casual: "Casual",
  date_night: "Date night",
  editorial: "Editorial",
  sustainable: "Sustainable",
  athleisure: "Athleisure",
  maternity: "Maternity",
  menswear: "Menswear",
  womenswear: "Womenswear",
  hair: "Hair",
  makeup: "Makeup",
};

export const SPECIALTY_KEYS = Object.keys(SPECIALTY_LABELS);
export const PRICE_TIERS = ["affordable", "premium", "luxury"];
export const TARGET_GENDERS = ["all", "male", "female"];

export const prettySpecialty = (s) => SPECIALTY_LABELS[s] || s;

/** Compact "96% match" pill for stylist cards. */
export function StyleMatchPill({ score, className = "" }) {
  if (typeof score !== "number") return null;
  return (
    <span
      data-testid="style-match-pill"
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] px-2 py-1 border border-accent text-accent ${className}`}
    >
      <span className="font-serif text-sm leading-none">{score}%</span> match
    </span>
  );
}

/** Verification status badge — Admin / Studio use this. */
export function VerificationBadge({ status }) {
  if (!status) return null;
  const map = {
    pending: { label: "Under review", cls: "border-amber-500 text-amber-600" },
    approved: { label: "Verified", cls: "border-accent text-accent" },
    rejected: { label: "Rejected", cls: "border-destructive text-destructive" },
    suspended: { label: "Suspended", cls: "border-destructive text-destructive" },
  };
  const it = map[status] || map.pending;
  return (
    <span
      data-testid={`verification-badge-${status}`}
      className={`inline-flex items-center text-[9px] uppercase tracking-[0.22em] px-2 py-0.5 border ${it.cls}`}
    >
      {it.label}
    </span>
  );
}
